import { Creative } from './creative';

export enum CreativeMediaVariantStatus {
    PENDING = 'PENDING',
    PROCESSING = 'PROCESSING',
    READY = 'READY',
    FAILED = 'FAILED',
}

export enum CreativeMediaVariantType {
    MP4 = 'MP4',
    HLS = 'HLS',
    DASH = 'DASH',
}

export interface CreativeMediaVariant {
    id: number;
    creative: Creative;
    url: string | null;
    mimeType: string | null;
    duration: number | null;
    videoBitrate: number | null;
    audioBitrate: number | null;
    width: number | null;
    height: number | null;
    transcodeElapsedMs: number | null;
    status: CreativeMediaVariantStatus;
    variantType: CreativeMediaVariantType;
    segmentDuration: number | null;
    minBitrate: number | null;
    maxBitrate: number | null;
}
